<template>
    <div style="color: #c1c1c1;border-bottom: 1px solid #e0e0e6; padding-top: 10px; padding-bottom: 10px;margin-bottom: 5px; vertical-align: middle">
        共{{dataSource.length}}条历史记录
        <span style="float: right;">
            <HomeIcon/>
        </span>
    </div>
    <a-spin :spinning="loading">
        <div style="text-align: left!important;">
            <tempate v-for="(item, k) in dataSource" :key="k">
                <a-card style="background: #fff; margin-top: 10px" size="small">
                    <span style="color: #d7d7db; padding-left: 9px">
                        <FilePdfOutlined style="color: red"/> {{item.add_time}}
                    </span>
                    <a-typography-paragraph :ellipsis="true" :class="item.upload_no === upload_no ? 'text active': 'text'">
                        <span style="cursor: pointer; font-size: 18px" @click="()=>overviewDetail(item)">{{item.title_cn}}</span>
                    </a-typography-paragraph>
                </a-card>
            </tempate>

        </div>
    </a-spin>
</template>

<script>
    import {FilePdfOutlined} from '@ant-design/icons-vue';
    import {get_args, isDEV} from "@/utils/request";
    import {
        get_aftergo_paper_upload_mine,
        jumpToDetail
    } from "@/utils/bioinfo.api";
    import { jumpToLogin} from "../../utils/llm.tools";
    import HomeIcon from "../../components/HomeIcon";
    import {post_auth_token_confirm} from "../../utils/paper.account";
    export default {
        name: "PaperRecent",
        components: {
            FilePdfOutlined,
            HomeIcon
        },
        props: ['uploadNo', 'collapsed'],
        data(){
            let {upload_no} = get_args();
            return {
                isDEV,
                upload_no: Number(upload_no),
                loading: true,
                dataSource: [],
                page: 1,
                pageSize: 10,
                total: 0,
            }
        },
        created(){
            post_auth_token_confirm(res=>{
               console.log('post_auth_token_confirm res', res);
               let {status} = res;
               if(status !== 1) jumpToLogin();
               else this.getItems(this.page, this.pageSize);
            });
        },
        methods: {
            getItems(){
                this.loading = true;
                get_aftergo_paper_upload_mine( res=>{
                    console.log('get_aftergo_paper_upload_mine mobile', res);
                    this.loading = false;
                    this.dataSource = res?.data || [];
                    this.total = res?.total_records;
                });
            },
            overviewDetail(record){
                console.log(record);
                let {upload_no, paper_no} = record;
                jumpToDetail(upload_no, paper_no);
            },
        }
    }
</script>

<style scoped>
    .text{
        background: #fff;
        line-height: 12px;
        border-radius: 10px;
        padding: 10px;
        padding-right: 3px;
        margin-bottom: 0;
    }
    .active, .text:hover{
        background: #EAEAEA;
    }

    /*{*/
    /*  xs: '480px',*/
    /*  sm: '576px',*/
    /*  md: '768px',*/
    /*  lg: '992px',*/
    /*  xl: '1200px',*/
    /*  xxl: '1600px',*/
    /*}*/
    /* 当视口宽度小于 600px 时 */
    @media (max-width: 480px) {
        .pubmed-width {
            width: 100%;
            /*border: 1px solid red;*/
            overflow-wrap: break-word!important; /* 标准属性 */
            word-break: break-all;
        }
        .modal-width{
            width: 98%
        }
    }

    /* 隐藏滚动条 */
    ::-webkit-scrollbar {
        width: 0px; /* 设置滚动条宽度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1; /* 设置滚动条轨道背景颜色 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #999; /* 设置滚动条滑块颜色 */
    }

    /* 滚动条滑块悬停状态 */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块悬停状态颜色 */
    }
</style>